module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/oranges@3x_c64b17.jpg";